import React from 'react';
import './css/DiscountBanner.scss';
import dayjs from 'dayjs';

const ProductChangeNote = ({ nextBillingCycleStr }) => {
  if (!nextBillingCycleStr) return null;
  if (dayjs(nextBillingCycleStr).isBefore(dayjs(), 'day')) return null;

  return (
    <div className="mt-2">
      <p className="mb-3">
        <b>NOTE:</b> Any changes you make to your product will take effect after your next billing cycle on{' '}
        <b>{nextBillingCycleStr}</b>.
      </p>
      <p>
        If you would like it sooner,{' '}
        <a target="_blank" className="underlined" href="mailto:support@maximustribe.com" rel="noreferrer">
          contact a Maximus concierge team member
        </a>{' '}
        to make a change to your current subscription.
      </p>
    </div>
  );
};

export default ProductChangeNote;
